import { Button as MUIButton, styled } from "@mui/material";

export const ButtonBasic = styled(MUIButton)(({ theme }) => ({
  display: "flex",
  justifyContent: "start",
  textTransform: "none",
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  paddingLeft: theme.spacing(1.5),
  paddingRight: theme.spacing(1.5),
  fontSize: theme.typography.body1.fontSize,
  fontWeight: theme.typography.body1.fontWeight,
}));
